const emptyPersonal = {
	firstName: '',
	lastName: '',
	jobTitle: '',
	phoneNumber: '',
	email: '',
	address: '',
	description: '',
};

const emptyEducation = {
	institute: '',
	location: '',
	degree: '',
	subject: '',
	from: '',
	to: '',
};

const emptyExperience = {
	position: '',
	company: '',
	location: '',
	from: '',
	to: '',
};

export { emptyPersonal, emptyEducation, emptyExperience };
